import { Avatar, Button, IconButton, Tooltip } from '@mui/material';
import * as XLSX from 'sheetjs-style';

import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function DefaultExcelExport({
    titleRows,
    headerRow,
    dataRows,
    fileName,
    iconButton,
    buttonText,
    disabledCondition,
    callbackFunction
}) {
    const handleExportToExcel = () => {
        // Create sheet array and push data to array
        let sheetData = [];

        if (titleRows) {
            titleRows.forEach(row => {
                sheetData.push(row);
            });
        }

        sheetData.push(headerRow);

        dataRows.forEach(row => {
            sheetData.push(row);
        });

        // Define necessary components
        const headerRowIndex = titleRows ? titleRows.length : 0;
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Determine and set column width based on header row
        const columnWidths = sheetData[headerRowIndex].map((_, colIndex) => ({
            wch: Math.max(
                ...sheetData.slice(headerRowIndex).map(row => (row[colIndex] ? row[colIndex].toString().length : 10))
            ) + 2
        }));
        worksheet['!cols'] = columnWidths;

        // Cell style
        const cellStyle = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
            },
            alignment: {
                horizontal: "center",
                vertical: "center"
            }
        };

        // Header cell style
        const headerStyle = {
            ...cellStyle,
            font: { bold: true }
        };

        // Apply styles to all cells with data
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let R = range.s.r; R <= range.e.r; R++) {
            // Skip rows above the header row
            if (R < headerRowIndex) continue;

            for (let C = range.s.c; C <= range.e.c; C++) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (!worksheet[cellAddress]) continue;
                worksheet[cellAddress].s = R === headerRowIndex ? headerStyle : cellStyle;
            }
        }

        // Write data to file and download
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, `${fileName}.xlsx`);

        if (callbackFunction) callbackFunction();
    };

    return (
        <>
            {iconButton ? (
                <Tooltip title={buttonText} placement="left" arrow>
                    <span>
                        <IconButton disabled={disabledCondition || headerRow?.length <= 0 || dataRows?.length <= 0} onClick={handleExportToExcel}>
                            <Avatar sx={{ bgcolor: (disabledCondition || headerRow?.length <= 0 || dataRows?.length <= 0) ? 'grey' : 'secondary.main', p: 0.5 }}>
                                <FileDownloadIcon sx={{ color: 'white.main', fontSize: 40 }} />
                            </Avatar>
                        </IconButton>
                    </span>
                </Tooltip>
            ) : (
                <Button sx={{ width: 'auto', height: 1 }} variant="outlined" color="success" disabled={disabledCondition || headerRow?.length <= 0 || dataRows?.length <= 0} onClick={handleExportToExcel}>
                    {buttonText}
                </Button>
            )}
        </>
    );
}
